import Header4i from '../header/header.js';
import Footer4i from '../footer/footer.js';
import ScrollToTop4i from '../../common/scrolltotop25.js';
import ImageError4i from '../../common/imageerror25.js';
//TODO: Uncomment and test these imports
//import SiteImprove from '../../../thirdparty/siteimprove/siteimprove.js';
//import KameleoonTest from '../../../thirdparty/kameleoon/kameleoontest.js';
//import ServiceWorker from '../../../thirdparty/serviceworker/serviceworker.js';

async function init() {
    if (!('inert' in HTMLElement.prototype) || !('loading' in HTMLImageElement.prototype)) {
        const { default: banner } = await import('../../common/upgradebrowser.js');
        banner.init();
    }

    if(document.getElementById("needsRecaptcha")){
        const { default: recaptcha } = await import('../../thirdparty/recaptcha/recaptcha.js');
        recaptcha.init();
    }

    ImageError4i.init();
    Header4i.init();
    ScrollToTop4i.init();
    Footer4i.init();

    //todo does this need to be in the head in layout file?
    //todo uncomment and test
    /*if(document.getElementById("needsNoibu")?.value === "true") {
        const { default: noibu } = await import('../../../thirdparty/noibu/noibu.js');
        noibu.init();
    }*/

    //todo test all of these
    //SiteImprove.init(); //todo uncomment and test
    //KameleoonTest.init(); //todo uncomment and test
    //ServiceWorker.init(); //todo uncomment and test
}

await init();